class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('.predictive-search-item');

    if (!this.input || !this.predictiveSearchResults) return;
    PredictiveSearch.nextId = (PredictiveSearch.nextId || 0) + 1;
    this.instanceId = 'predictive-search-' + PredictiveSearch.nextId;
    this.input.id = this.instanceId + '-input';
    this.predictiveSearchResults.id = this.instanceId + '-results';

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.predictiveSearchResults.querySelectorAll('[id]').forEach((element) => {
          const oldId = element.id;
          element.id = this.instanceId + '-' + oldId;
          this.predictiveSearchResults.querySelectorAll('[aria-labelledby]').forEach((labelled) => {
            labelled.setAttribute('aria-labelledby', labelled.getAttribute('aria-labelledby').split(' ').map((id) => id === oldId ? element.id : id).join(' '));
          });
        });
        const list = this.predictiveSearchResults.querySelector('[role="listbox"]');
        if (list) this.input.setAttribute('aria-controls', list.id);
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.input.setAttribute('aria-expanded', 'true');
  }

  close() {
    if (!this.predictiveSearchResults) return;
    this.predictiveSearchResults.style.display = 'none';
    this.input.setAttribute('aria-expanded', 'false');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
